const initial = false;

export const TOGGLE_EDIT_MODE = "TOGGLE_EDIT_MODE";

/**
 * Reducer for isEditMode
 */
export function isEditModeReducer(state = initial, action) {
  if (action.type === TOGGLE_EDIT_MODE) {
    return !state;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/components/mySCC/common/reducers/IsEditModeReducer.js